import { getToken, clearToken } from './auth'

// Recupera idioma, país, zona horaria y hora desde el cache local.
export function getCompanyLocaleInfo() {
  if (typeof window === 'undefined') return null;

  const settingsStr = window.localStorage.getItem('company_settings');
  if (!settingsStr) return null;

  let settings;
  try {
    settings = JSON.parse(settingsStr);
  } catch {
    return null;
  }

  // Solo usar datos de la tabla settings
  const idioma = settings.language || 'en';
  const pais = settings.country || 'US';
  const zonaHoraria = settings.timezone || 'America/Los_Angeles';
  // Usar taskPublishTime como fuente principal de hora de corte
  let hora = '23:00';
  if (settings.taskPublishTime) {
    hora = settings.taskPublishTime;
  } else if (settings.hour) {
    hora = settings.hour;
  }
  return { idioma, pais, zonaHoraria, hora, taskPublishTime: settings.taskPublishTime };
}

// Calcula la hora local para obtener tareas del día siguiente
export function getNextDayTaskTime() {
  const now = new Date();
  // Ajusta a la zona horaria de la empresa si está en settings
  const settingsStr = window.localStorage.getItem('company_settings');
  let tz = 'America/Los_Angeles';
  if (settingsStr) {
    try {
      const settings = JSON.parse(settingsStr);
      if (settings.timezone) tz = settings.timezone;
    } catch {}
  }
  // Obtiene la hora local en la zona horaria
  const nextDay = new Date(now);
  nextDay.setDate(now.getDate() + 1);
  // Devuelve la fecha y hora en la zona horaria
  return nextDay.toLocaleString('en-US', { timeZone: tz });
}

// Recupera y almacena settings completos en localStorage
export async function getCompanySettings() {
  try {
    const token = getToken();
    if (!token || typeof token !== 'string' || !token.trim()) {
      return null;
    }
    // Usar API_URL y endpoint correcto
    const { API_URL } = await import('./config');
    const url = `${API_URL}/company/settings`;
    const headers = { 'Authorization': `Bearer ${token}` };
    const res = await fetch(url, { headers });
    if (res.status === 401) {
      // Token inválido o expirado: limpiar y forzar logout
      clearToken();
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem('company_settings');
        window.localStorage.removeItem('company_name');
        window.localStorage.removeItem('lang');
        window.localStorage.removeItem('task_publish_time');
      }
      return null;
    }
    if (!res.ok) return null;
    const result = await res.json();
    const settings = result && result.data ? result.data : result;
    if (settings && typeof window !== 'undefined') {
      window.localStorage.setItem('company_settings', JSON.stringify(settings));
      if (settings.language) window.localStorage.setItem('lang', settings.language);
      if (settings.name) window.localStorage.setItem('company_name', settings.name);
      if (settings.taskPublishTime) window.localStorage.setItem('task_publish_time', settings.taskPublishTime);
      // Mostrar en consola lo que quedó guardado
      const stored = {
        company_settings: window.localStorage.getItem('company_settings'),
        lang: window.localStorage.getItem('lang'),
        company_name: window.localStorage.getItem('company_name'),
        task_publish_time: window.localStorage.getItem('task_publish_time'),
      };
    }
    return settings;
  } catch {
    return null;
  }
}

// Para compatibilidad: obtener solo el nombre
export async function getCompanyName() {
  const settings = await getCompanySettings();
  return settings && settings.name ? settings.name : null;
}
